<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-11-28 20:52:15
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/PanelOne.vue
-->
 
<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table">
    <span slot="remainstatus" slot-scope="text,record">
      <a-tag
        :color="$filterDictTextByCache('bpbj_inventory_color',record.leftCount> record.prepareCount?1:0)"
      >{{record.leftCount>=record.prepareCount?'库存充足':'库存不足'}}</a-tag>
    </span>
  </grid-table>
  <!-- <dev-inventory-list viewType="noShow"/> -->
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";

  export default {
    name: 'PendingOne',
    components: {
      GridTable,
    },

    // 定义属性
    data () {
      return {
        url: '/spareparts/devBpbjInfo/stock/list',
        queryParams: {
          stockFlag: 1
        },
        columns: [
          {
            title: '备件名称',
            align: 'center',
            dataIndex: 'bjName'
          },
          {
            title: '备件型号',
            align: 'center',
            dataIndex: 'bjModel'
          },
          {
            title: '规格',
            align: 'center',
            dataIndex: 'bjModelSpec'
          },
          {
            title: '生产厂家',
            align: 'center',
            dataIndex: 'manuName'
          },
          {
            title: '应备数量',
            align: 'center',
            dataIndex: 'prepareCount'
          },
          // 库存
          {
            title: '库存',
            align: 'center',
            dataIndex: 'leftCount'
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'unit'
          },
          {
            title: '状态',
            dataIndex: 'delFlag',

            align: 'center',
            scopedSlots: { customRender: 'remainstatus' }
          },
        ]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>